<template>
  <b-container fluid>
    <b-row>
      <b-col>
        <div class="username">
          <i class="far fa-user"></i>
          {{ fullname }}
        </div>
        <h1>VUE D'ENSEMBLE</h1>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <div class="ibox" v-if="$root.isAuthorized('renting-preparation_index')">
          <routerLink :to="{ name: 'RentingPreparationMobileList' }">
            <div class="ibox-content indicator">
              <div class="flex-grow-1">
                <dl>
                  <dt>Demandes de préparations</dt>
                  <dd>En attente</dd>
                </dl>
              </div>
              <h2>
                {{
                  $store.getters["renting_preparation/getByStatusSlug"](
                    "renting-preparation-en-attente-de-preparation"
                  ).filter(
                    (item) =>
                      item.preparator && item.preparator.id == this.$store.getters["auth/id"]
                  ).length
                }}
                <i class="far fa-long-arrow-right fa-xs"></i>
              </h2>
            </div>
          </routerLink>
        </div>
        <div class="ibox" v-if="$root.isAuthorized('business-return_index')">
          <routerLink :to="{ name: 'ReceptionMobileList' }">
            <div class="ibox-content indicator">
              <div class="flex-grow-1">
                <dl>
                  <dt>Réceptions</dt>
                  <dd>Retours clients et transferts inter-entrepôts</dd>
                </dl>
              </div>
              <h2>
                {{ myBusinessReturns.length + incomingTransfers.length }}
                <i class="far fa-long-arrow-left fa-xs"></i>
              </h2>
            </div>
          </routerLink>
        </div>
        <div class="ibox" v-if="$root.isAuthorized('shipping_index')">
          <routerLink :to="{ name: 'ShippingMobileList' }">
            <div class="ibox-content indicator">
              <div class="flex-grow-1">
                <dl>
                  <dt>Fiches d'expédition</dt>
                  <dd>En attente de solution transport</dd>
                </dl>
              </div>
              <h2>
                {{
                  $store.getters["shipping/getByStatusSlug"]([
                    "shipping-en-preparation",
                    "shipping-en-attente-de-solution-de-transport",
                  ]).length
                }}
                <i class="far fa-truck fa-xs"></i>
              </h2>
            </div>
          </routerLink>
        </div>
        <b-button variant="primary" size="lg" class="w-100" :to="{ name: 'ReferenceMobileScan' }"
          >Scanner une référence</b-button
        >
        <b-button
          variant="outline-secondary"
          size="sm"
          class="w-100 mt-10"
          :to="{ name: 'ReferenceMobileScanDebug' }"
          >Debug scan</b-button
        >
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
export default {
  name: "HomeMobile",
  data() {
    return {
      incomingTransfers: [],
    };
  },
  computed: {
    fullname() {
      return this.$store.getters["auth/fullname"];
    },
    myBusinessReturns() {
      return this.$store.getters["business_return/getByStatusSlug"](
        "business-return-transport-en-cours"
      ).filter((item) => {
        if (
          this.$root.isAuthorized("business-return_im-preparator") &&
          item.group_slugs.includes("instruments")
        ) {
          return true;
        }
        if (
          this.$root.isAuthorized("business-return_ot-preparator") &&
          item.group_slugs.includes("outillage")
        ) {
          return true;
        }
        if (
          this.$root.isAuthorized("business-return_snl-preparator") &&
          item.group_slugs.includes("service_et_logistique")
        ) {
          return true;
        }
        return false;
      });
    },
  },
  mounted() {
    const self = this;

    this.loadIncomingTransfers();

    if (this.$root.isAuthorized("renting-preparation_index")) {
      this.$store.dispatch("renting_preparation/getMineByStatusSlug", [
        "renting-preparation-en-attente-de-preparation",
      ]);
    }
    if (this.$root.isAuthorized("business-return_index")) {
      this.$store.dispatch("business_return/getByStatusSlug", [
        "business-return-transport-en-cours",
      ]);
    }
    if (this.$root.isAuthorized("shipping_index")) {
      this.$store.dispatch("shipping/getByStatusSlug", [
        "shipping-en-preparation",
        "shipping-en-attente-de-solution-de-transport",
      ]);
    }
  },
  methods: {
    /**
     * Transferts inter-entrepôts encore en transit vers l'entrepôt de l'utilisateur.
     */
    loadIncomingTransfers() {
      if (!this.$root.isAuthorized("business-return_index")) {
        return;
      }

      const warehouse = this.$store.getters["auth/warehouse"];
      const params = {
        status: "warehouse-transfer-envoye,warehouse-transfer-receptionne-partiellement",
      };
      if (warehouse && warehouse.id) {
        params.target = warehouse.id;
      }

      this.$http
        .get(process.env.BACK_API_URL + "warehouse-transfer", { params })
        .then((response) => {
          this.incomingTransfers = (response.data && response.data.transfers) || [];
        })
        .catch(() => {});
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/_variables.scss";

.username {
  font-size: 13px;
  color: $text-50p;
}
h1 {
  margin-top: 5px;
}

.ibox {
  margin-bottom: 10px;
  .ibox-content dl {
    font-size: 13px;
  }
  a {
    color: $text;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/HomeMobile.vue